import React from 'react'
import './Section4.css'

const Section4 = () => {
  return (
    <div className="section1-container" id='NEW'>
        <img src="https://res.cloudinary.com/facemetaclone/image/upload/v1662240814/IMAGE-landscape-fill-be630125-a936-42b9-9a38-c204eaeb4597-default_0_wtecwb.jpg" alt="" />
    </div>
  )
}

export default Section4